/* Modimania front — thème Shopify (porté de modimania-front.js v7) */
(function(){
'use strict';

/* ---------- Nav : burger + méga-menus (tactile) ---------- */
document.addEventListener('click',function(e){
	var burger=e.target.closest('.mdm-nav-burger');
	if(burger){
		var menu=document.querySelector('.mdm-nav-menu');
		if(menu){var open=menu.classList.toggle('mdm-nav-menu-ouvert');burger.setAttribute('aria-expanded',open?'true':'false');}
		return;
	}
	var link=e.target.closest('.mdm-has-mega > .mdm-nav-link');
	if(link){
		e.preventDefault();
		var item=link.parentElement;
		var wasOpen=item.classList.contains('mdm-mega-ouvert');
		document.querySelectorAll('.mdm-nav-item.mdm-mega-ouvert').forEach(function(it){
			it.classList.remove('mdm-mega-ouvert');
			var b=it.querySelector('.mdm-nav-link');if(b){b.setAttribute('aria-expanded','false');}
		});
		if(!wasOpen){item.classList.add('mdm-mega-ouvert');link.setAttribute('aria-expanded','true');}
		return;
	}
	if(!e.target.closest('.mdm-mega')){
		document.querySelectorAll('.mdm-nav-item.mdm-mega-ouvert').forEach(function(it){
			it.classList.remove('mdm-mega-ouvert');
			var b=it.querySelector('.mdm-nav-link');if(b){b.setAttribute('aria-expanded','false');}
		});
	}
});
document.addEventListener('mouseover',function(e){
	if(!e.target.closest('.mdm-nav-menu')){return;}
	var navItem=e.target.closest('.mdm-nav-item');
	var keep=(navItem&&navItem.classList.contains('mdm-has-mega'))?navItem:null;
	document.querySelectorAll('.mdm-nav-item.mdm-mega-ouvert').forEach(function(it){
		if(it!==keep){it.classList.remove('mdm-mega-ouvert');var b=it.querySelector('.mdm-nav-link');if(b){b.setAttribute('aria-expanded','false');}}
	});
});

/* ---------- Galerie fiche : bascule pixel / photo ---------- */
document.addEventListener('click',function(e){
	var tab=e.target.closest('.mdm-tab');
	if(!tab){return;}
	var wrap=tab.closest('.mdm-galerie');
	if(!wrap){return;}
	wrap.querySelectorAll('.mdm-tab').forEach(function(b){b.classList.remove('mdm-tab-active');b.setAttribute('aria-pressed','false');});
	tab.classList.add('mdm-tab-active');tab.setAttribute('aria-pressed','true');
	var show=tab.getAttribute('data-mdm-show');
	wrap.querySelectorAll('.mdm-galerie-panel').forEach(function(p){
		p.classList.toggle('mdm-galerie-panel-hidden',p.getAttribute('data-mdm-panel')!==show);
	});
});

/* ---------- Sommaire auto d'article ---------- */
(function(){
	var toc=document.querySelector('[data-mm-toc]');
	var art=document.querySelector('.mm-a-body');
	if(!toc||!art){return;}
	var heads=art.querySelectorAll('h2, h3');
	var list=toc.querySelector('.mm-a-toc-list');
	var items=[];
	Array.prototype.forEach.call(heads,function(h,i){
		if(!h.id){h.id='sec-'+(i+1);}
		var li=document.createElement('li');
		if(h.tagName==='H3'){li.className='lvl3';}
		var a=document.createElement('a');
		a.href='#'+h.id;a.textContent=h.textContent;
		a.addEventListener('click',function(e){e.preventDefault();var t=document.getElementById(h.id);if(t){t.scrollIntoView({behavior:'smooth'});history.replaceState(null,'','#'+h.id);}});
		li.appendChild(a);list.appendChild(li);items.push({a:a,h:h});
	});
	if(!items.length){return;}
	toc.hidden=false;
	var onScroll=function(){
		var y=window.scrollY+100,cur=items[0];
		items.forEach(function(it){if(it.h.getBoundingClientRect().top+window.scrollY<=y){cur=it;}});
		items.forEach(function(it){it.a.classList.toggle('is-active',it===cur);});
	};
	window.addEventListener('scroll',onScroll,{passive:true});
	onScroll();
})();

/* ============================================================
   DONNÉES CATALOGUE (JSON sur le CDN Shopify)
   ============================================================ */
var DATA_URL=(window.MDM&&MDM.data)||'https://cdn.shopify.com/s/files/1/0951/0069/9005/files/modimania-data-v9.json?v=1788271291';
var COLORS={H02:['#FFFAD2','Blanc / Crème'],H03:['#FFD700','Jaune'],H05:['#D92C2C','Rouge'],H06:['#FFC0CD','Rose'],H07:['#7B57B2','Violet'],H08:['#003399','Bleu foncé'],H10:['#3A8F46','Vert'],H104:['#C0E74F','Vert citron'],H107:['#666699','Lavande'],H116:['#000000','Noir'],H18:['#000000','Noir'],H21:['#B47D29','Marron clair'],H22:['#B3202A','Rouge foncé'],H09:['#0066CC','Bleu'],H36:['#0066CC','Bleu'],H45:['#BFA4DD','Violet pastel'],H46:['#A3CFE9','Bleu pastel'],H49:['#A3CFE9','Bleu pastel'],H105:['#F6C1A3','Orange Abricot clair'],H60:['#F6C1A3','Orange Abricot clair'],H70:['#CCCCCC','Gris clair'],H71:['#4B4B4B','Gris foncé'],H75:['#E6C9B3','Beige café'],H79:['#F4A86E','Orange Abricot'],H84:['#6B8F24','Vert olive']};
var DIFF_STYLE={facile:['#0E6E62','#E7F3EF'],moyen:['#B07A22','#F5ECD8'],difficile:['#C2412A','#FBE9E3']};
var DIFF_RANK={facile:0,moyen:1,difficile:2};
function fold(s){return (s||'').toLowerCase().normalize('NFD').replace(/[̀-ͯ]/g,'');}
var _models=null;
/* 17 oct. 2026 — catalogue en mode « kits » (/collections/tous-les-kits) : les cartes mènent aux fiches kits. */
var KIT_MODE=false;
function fmtN(n){return String(n||0).replace(/\B(?=(\d{3})+(?!\d))/g,' ');}
function fmtPrix(p){return p.toFixed(2).replace('.',',')+' €';}
function loadModels(){
	if(_models){return Promise.resolve(_models);}
	return fetch(DATA_URL).then(function(r){return r.json();}).then(function(j){
		/* Prix du kit sans plaques = 10,90 € + 3 € par sachet de 1000 (avant regroupement des codes couleur) */
		j.forEach(function(m){var s=0;Object.keys(m.materiel||{}).forEach(function(c){s+=Math.ceil(m.materiel[c]/1000);});m._prix=Math.round((10.9+3*s)*100)/100;});
		j.forEach(function(m){if(m.materiel){if(m.materiel.H36!==undefined){m.materiel.H09=(m.materiel.H09||0)+m.materiel.H36;delete m.materiel.H36;}if(m.materiel.H49!==undefined){m.materiel.H46=(m.materiel.H46||0)+m.materiel.H49;delete m.materiel.H49;}if(m.materiel.H60!==undefined){m.materiel.H105=(m.materiel.H105||0)+m.materiel.H60;delete m.materiel.H60;}if(m.materiel.H116!==undefined){m.materiel.H18=(m.materiel.H18||0)+m.materiel.H116;delete m.materiel.H116;}}});
		j.forEach(function(m){m._couleurs=Object.keys(m.materiel||{}).length;m._q=(m.perso||'').toLowerCase();m._qf=fold(m.perso);m._num=parseInt((m.ref||'').replace(/\D/g,''),10)||0;if(m.modele_url&&m.modele_url.indexOf('/modeles/')===0){m.modele_url='/pages'+m.modele_url;}});
		_models=j;return j;
	});
}
/* 11 oct. 2026 — titre et alt alignés sur les cartes Liquid (mm-model-card) : « … en perles à repasser ». */
function cardHtml(m){
	var d=DIFF_STYLE[m.diff]||DIFF_STYLE.moyen;
	var diffCap=m.diff?m.diff.charAt(0).toUpperCase()+m.diff.slice(1):'';
	var badge='<span class="mdm-badge" style="color:'+d[0]+';background:'+d[1]+';">'+diffCap+'</span>';
	var meta='58×58 · '+m._couleurs+' couleurs · 4 plaques';
	var url=m.modele_url,titre=m.perso+' en perles à repasser',action='<span class="mdm-card-pdf">↓ PDF gratuit</span>';
	if(KIT_MODE){
		var slug=(m.modele_url||'').replace(/^.*\/perles-hama-midi-/,'').replace(/-58x58\/?$/,'');
		url='/products/kit-'+slug+'-perles-hama-midi';
		titre='Kit '+titre;
		meta=fmtN(m.perles)+' perles · '+m._couleurs+' couleurs · 58×58';
		action='<span class="mdm-card-pdf" style="color:#0E6E62;background:#E7F3EF;">Kit complet dès '+fmtPrix(m._prix)+'</span>';
	}
	return '<a class="mdm-card mm-lift" href="'+url+'">'
	+'<span class="mdm-card-visuel mm-grid-bg"><img src="'+m.img+'" alt="Modèle '+m.perso+' en perles à repasser" loading="lazy" width="150" height="150">'+(m.img_photo?'<img class="mdm-card-photo" src="'+m.img_photo+'" alt="" loading="lazy" aria-hidden="true">':'')+badge+'</span>'
	+'<span class="mdm-card-body"><span class="mdm-card-titre">'+titre+'</span>'
	+'<span class="mdm-card-meta mdm-mono">'+meta+'</span>'
	+'<span class="mdm-card-actions">'+action+'<span class="mdm-card-buy" aria-hidden="true">↗</span></span>'
	+'</span></a>';
}

/* ---------- Recherche live (nav + hero + catalogue) ---------- */
/* Entrées de navigation : univers, techniques, difficultés, outils.
   Chaque entrée est trouvable par son libellé ET par des mots-clés (synonymes). */
var NAV_ENTRIES=[
	{label:'Pokémon',sub:'Univers · 151 modèles',url:'/collections/kits-pokemon',glyph:'◉',color:'#DA4A2A',keys:['pokemon','univers','generation 1','pikachu kanto']},
	{label:'Halloween',sub:'Univers · 37 modèles',url:'/collections/kits-halloween',glyph:'◉',color:'#E8734F',keys:['halloween','univers','citrouille','fantome','sorciere','monstre','effrayant','toussaint','octobre','decoration','bonbons']},
	{label:'Ésotérisme',sub:'Univers · 19 modèles',url:'/collections/kits-esoterisme',glyph:'◉',color:'#7B57B2',keys:['esoterisme','esoterique','univers','tarot','attrape reves','boule de cristal','pentacle','grimoire','lune','mystique','sorcellerie','witchy','boheme']},
	{label:'Automne',sub:'Univers · 16 modèles',url:'/collections/kits-automne',glyph:'◉',color:'#B07A22',keys:['automne','univers','feuille','feuilles mortes','renard','champignon','citrouille','chataigne','gland','pomme','toussaint','saison']},
	{label:'Forêt',sub:'Univers · 15 modèles',url:'/collections/kits-foret',glyph:'◉',color:'#3A8F46',keys:['foret','univers','animaux','animaux de la foret','bois','nature','cerf','biche','faon','hibou','chouette','ours','ourson','renardeau','sanglier','blaireau','oiseau','mesange','rouge gorge','pic vert','champignon','cabane']},
	{label:'Spéciales',sub:'Univers · 13 modèles',url:'/collections/kits-speciales',glyph:'◉',color:'#4B6FD6',keys:['speciales','speciale','univers','noel','boule de noel','flocon','neige','etoile','etoiles','bougie','vitrail','attrape soleil','suncatcher','cristal','diamant','papillon','coquillage','meduse','eclair','fantome']},
	{label:'Perles Hama Midi',sub:'Technique · 251 modèles',url:'/collections/perles-hama-midi',glyph:'▦',color:'#DA4A2A',keys:['perle','perles','hama','midi','technique','pixel art','perles a repasser','repasser','beads']},
	{label:'Facile',sub:'Difficulté · modèles débutant',url:'/collections/kits-niveau-facile',glyph:'●',color:'#0E6E62',keys:['facile','debutant','simple','enfant','premier modele','niveau']},
	{label:'Moyen',sub:'Difficulté · niveau intermédiaire',url:'/collections/kits-niveau-moyen',glyph:'●',color:'#B07A22',keys:['moyen','intermediaire','niveau']},
	{label:'Difficile',sub:'Difficulté · modèles experts',url:'/collections/kits-niveau-difficile',glyph:'●',color:'#C2412A',keys:['difficile','dur','expert','avance','complexe','niveau']},
	{label:'Calculateur de perles',sub:'Outil · que faire avec mon stock ?',url:'/pages/calculateur-perles',glyph:'⌗',color:'#2FB39F',keys:['calculateur','calcul','combien de perles','stock','restes','outil']},
	{label:'Blog & guides',sub:'Ressources · conseils et tutos',url:'/blogs/blog',glyph:'✎',color:'#8A8072',keys:['blog','guide','conseil','tuto','article','aide','apprendre','debuter','repassage']}
];
/* 11 oct. 2026 — « Univers · N modèles » : N vient du thème (MDM.counts, nombre de produits
   de chaque collection), plus de nombre à mettre à jour à la main quand on ajoute des modèles. */
if(window.MDM&&MDM.counts){
	NAV_ENTRIES.forEach(function(n){
		var h=n.url.indexOf('/collections/')===0?n.url.slice(13):'';
		var c=h?MDM.counts[h]:0;
		if(c>0&&/\d+ modèles/.test(n.sub)){n.sub=n.sub.replace(/\d+ modèles/,c+' modèles');}
	});
}
/* Score d'un texte face à une requête pliée (sans accents) :
   correspondance exacte > début de texte > début de mot > sous-chaîne. */
function scoreText(qf,text){
	var t=fold(text);
	if(!t||!qf){return 0;}
	if(t===qf){return 100;}
	if(t.indexOf(qf)===0){return 80;}
	if(t.indexOf(' '+qf)>-1){return 60;}
	if(t.indexOf(qf)>-1){return 40;}
	return 0;
}
/* Requête multi-mots : chaque mot doit matcher (ET) ; le score est la somme. */
function scoreTokens(tokens,text){
	var total=0;
	for(var i=0;i<tokens.length;i++){
		var s=scoreText(tokens[i],text);
		if(!s){return 0;}
		total+=s;
	}
	return total;
}
function navMatches(tokens,qlen){
	var out=[];
	NAV_ENTRIES.forEach(function(n){
		var labelScore=scoreTokens(tokens,n.label);
		var best=labelScore;
		n.keys.forEach(function(k){
			/* Les mots-clés (synonymes) pèsent moins lourd que le libellé lui-même */
			var s=Math.round(scoreTokens(tokens,k)*0.7);
			if(s>best){best=s;}
		});
		/* Requête très courte (2 lettres) : on exige un vrai début de mot, pas une sous-chaîne */
		if(qlen<=2&&best<56){return;}
		if(best>0){out.push({n:n,score:best,labelScore:labelScore});}
	});
	out.sort(function(a,b){return b.score-a.score;});
	return out.slice(0,3);
}
function modelMatches(tokens,models){
	var out=[];
	models.forEach(function(m){
		var s=scoreTokens(tokens,m.perso);
		if(s>0){out.push({m:m,score:s});}
	});
	out.sort(function(a,b){
		if(b.score!==a.score){return b.score-a.score;}
		/* À score égal : le nom le plus court d'abord (la requête couvre plus du nom) */
		if(a.m.perso.length!==b.m.perso.length){return a.m.perso.length-b.m.perso.length;}
		return a.m.perso.localeCompare(b.m.perso,'fr');
	});
	return out.slice(0,6);
}
function navItemHtml(n){
	return '<a class="mdm-suggest-item" href="'+n.url+'">'
	+'<span class="mdm-suggest-img" style="display:flex;align-items:center;justify-content:center;font-size:17px;color:'+n.color+';">'+n.glyph+'</span>'
	+'<span class="mdm-suggest-txt"><span class="mdm-suggest-label">'+n.label+'</span>'
	+'<span class="mdm-suggest-sub">'+n.sub+'</span></span></a>';
}
function modelItemHtml(m){
	return '<a class="mdm-suggest-item" href="'+m.modele_url+'"><span class="mdm-suggest-img"><img src="'+m.img+'" alt="" loading="lazy"></span>'
	+'<span class="mdm-suggest-txt"><span class="mdm-suggest-label">'+m.perso+'</span>'
	+'<span class="mdm-suggest-sub">Niveau '+m.diff+' · '+m.perles+' perles · '+m._couleurs+' couleurs</span></span></a>';
}
function bindSuggest(form){
	var input=form.querySelector('input[type="text"],input[type="search"]');
	if(!input){return;}
	/* Le panneau est positionné en absolu : le formulaire doit être son ancre.
	   (.mdm-nav-search l'a déjà en CSS ; .mdm-hero-search et .mdm-recherche-form non) */
	if(window.getComputedStyle(form).position==='static'){form.style.position='relative';}
	var panel=null,timer=null;
	function close(){if(panel){panel.remove();panel=null;}}
	function open(html){
		close();
		panel=document.createElement('div');
		panel.className='mdm-suggest';
		panel.innerHTML=html;
		form.appendChild(panel);
		/* Filet de sécurité si la CSS du panneau n'est pas chargée sur cette page */
		var cs=window.getComputedStyle(panel);
		if(cs.position==='static'){
			panel.style.cssText+='position:absolute;top:calc(100% + 8px);left:0;right:0;background:#fff;border:1px solid #E7DECD;border-radius:12px;box-shadow:0 20px 44px -28px rgba(33,29,24,.5);max-height:420px;overflow:auto;z-index:80;';
		}
	}
	input.addEventListener('input',function(){
		if(timer){clearTimeout(timer);}
		timer=setTimeout(function(){
			var raw=input.value.trim();
			var qf=fold(raw);
			if(qf.length<2){close();return;}
			loadModels().then(function(models){
				if(fold(input.value.trim())!==qf){return;}
				var tokens=qf.split(/\s+/).filter(Boolean);
				var navs=navMatches(tokens,qf.length);
				var hits=modelMatches(tokens,models);
				var catalog=(window.MDM&&MDM.catalog)||'/pages/modeles';
				if(!navs.length&&!hits.length){
					open('<div class="mdm-suggest-empty"><p>Aucun résultat pour « '+raw.replace(/</g,'&lt;')+' ».</p><a class="mdm-suggest-cta" href="'+catalog+'">Parcourir le catalogue</a></div>');
					return;
				}
				/* Navigation AVANT les modèles uniquement si son libellé matche fortement
				   (« facile », « pokemon », « blog »…) ; sinon les modèles priment et la
				   navigation vient après, limitée à 2 suggestions. */
				var strong=navs.filter(function(x){return x.labelScore>=80;});
				var weak=navs.filter(function(x){return x.labelScore<80;}).slice(0,hits.length?2:3);
				var html='';
				strong.forEach(function(x){html+=navItemHtml(x.n);});
				hits.forEach(function(x){html+=modelItemHtml(x.m);});
				weak.forEach(function(x){html+=navItemHtml(x.n);});
				if(hits.length){html+='<a class="mdm-suggest-all" href="'+catalog+'?s='+encodeURIComponent(raw)+'">Voir tous les résultats →</a>';}
				open(html);
			});
		},140);
	});
	document.addEventListener('click',function(e){if(panel&&!form.contains(e.target)){close();}});
	form.addEventListener('submit',function(e){
		e.preventDefault();
		var catalog=(window.MDM&&MDM.catalog)||'/pages/modeles';
		window.location=catalog+'?s='+encodeURIComponent(input.value.trim());
	});
}
document.querySelectorAll('.mdm-nav-search,.mdm-hero-search,.mdm-recherche-form').forEach(bindSuggest);

/* ============================================================
   CATALOGUE : filtres sans rechargement (client-side)
   ============================================================ */
var cat=document.querySelector('[data-mdm-catalogue]');
if(!cat){return;}
var limit=parseInt(cat.getAttribute('data-limit'),10)||24;
KIT_MODE=cat.getAttribute('data-mode')==='kits';
var baseDiff=cat.getAttribute('data-diff')||'';
var baseUniv=cat.getAttribute('data-univers')||'';
var grid=cat.querySelector('[data-mdm-grid]');
var vide=cat.querySelector('[data-mdm-vide]');
var countNum=cat.querySelector('.mdm-count-num');
var countS=cat.querySelector('.mdm-count-s');
var actifs=cat.querySelector('.mdm-actifs');
var loadWrap=cat.querySelector('.mdm-loadmore-wrap');
var shown=limit;

function stateFromUrl(){
	var p=new URLSearchParams(window.location.search);
	return {
		difficulte:p.get('difficulte')||baseDiff,
		s:(p.get('s')||'').toLowerCase(),
		tri:p.get('tri')||'az',
		couleurs:(p.get('couleurs')||'').split(',').filter(Boolean)
	};
}
var state=stateFromUrl();

function syncUrl(){
	var p=new URLSearchParams();
	if(state.difficulte&&state.difficulte!==baseDiff){p.set('difficulte',state.difficulte);}
	if(state.s){p.set('s',state.s);}
	if(state.tri&&state.tri!=='az'){p.set('tri',state.tri);}
	if(state.couleurs.length){p.set('couleurs',state.couleurs.join(','));}
	var qs=p.toString();
	history.replaceState(null,'',window.location.pathname+(qs?'?'+qs:''));
}
/* Nombre de perles du modèle dans les couleurs sélectionnées */
function selCount(m,sel){
	var t=0;
	sel.forEach(function(c){t+=(m.materiel&&m.materiel[c])||0;});
	return t;
}
function filtered(models){
	var sf=fold(state.s);
	var out=models.filter(function(m){
		/* Page collection d'univers : on reste dans l'univers de la page.
		   Garde de compatibilité : si le JSON ne porte pas encore le champ
		   `univers`, on ne filtre pas (comportement historique). */
		if(baseUniv&&m.univers&&m.univers!==baseUniv){return false;}
		if(state.difficulte&&m.diff!==state.difficulte){return false;}
		if(sf&&m._qf.indexOf(sf)===-1){return false;}
		if(state.couleurs.length){
			/* Filtre en ET : le modèle doit contenir TOUTES les couleurs sélectionnées */
			var ok=state.couleurs.every(function(c){return m.materiel&&m.materiel[c];});
			if(!ok){return false;}
		}
		return true;
	});
	var tri=state.tri;
	var sel=state.couleurs;
	out.sort(function(a,b){
		/* Couleurs sélectionnées : d'abord les modèles qui en contiennent le plus de perles */
		if(sel.length){
			var d=selCount(b,sel)-selCount(a,sel);
			if(d){return d;}
		}
		if(tri==='za'){return b.perso.localeCompare(a.perso,'fr');}
		if(tri==='simple'){
			/* Du plus facile au plus compliqué : moins de perles d'abord, puis moins de couleurs */
			var p=(a.perles||0)-(b.perles||0);
			if(p){return p;}
			if(a._couleurs!==b._couleurs){return a._couleurs-b._couleurs;}
			return a.perso.localeCompare(b.perso,'fr');
		}
		if(tri==='complexe'){
			/* Du plus compliqué au plus facile : plus de perles d'abord, puis plus de couleurs */
			var pc=(b.perles||0)-(a.perles||0);
			if(pc){return pc;}
			if(a._couleurs!==b._couleurs){return b._couleurs-a._couleurs;}
			return a.perso.localeCompare(b.perso,'fr');
		}
		if(tri==='recent'){return b._num-a._num;}
		return a.perso.localeCompare(b.perso,'fr');
	});
	return out;
}
function renderChips(){
	cat.querySelectorAll('.mm-chip[data-tax="difficulte"]').forEach(function(chip){
		var active=chip.getAttribute('data-val')===state.difficulte;
		chip.setAttribute('aria-pressed',active?'true':'false');
		var dot=chip.querySelector('.mdm-dot');
		if(dot){dot.style.background=active?'currentColor':(DIFF_STYLE[chip.getAttribute('data-val')]||['#8A8072'])[0];}
	});
	cat.querySelectorAll('.mdm-swatch-btn').forEach(function(btn){
		btn.setAttribute('aria-pressed',state.couleurs.indexOf(btn.getAttribute('data-couleur'))>-1?'true':'false');
	});
	var tri=cat.querySelector('.mdm-tri');
	if(tri){tri.value=state.tri;}
	var sInput=cat.querySelector('.mdm-recherche-form input');
	if(sInput&&sInput.value.toLowerCase()!==state.s){sInput.value=state.s;}
}
function renderActifs(){
	if(!actifs){return;}
	var html='';
	function pill(tax,val,label){return '<button type="button" class="mdm-pill-active" data-tax="'+tax+'" data-val="'+val+'">'+label+' <span aria-hidden="true">✕</span></button>';}
	if(state.difficulte&&state.difficulte!==baseDiff){html+=pill('difficulte',state.difficulte,state.difficulte.charAt(0).toUpperCase()+state.difficulte.slice(1));}
	if(state.s){html+=pill('s',state.s,'« '+state.s+' »');}
	state.couleurs.forEach(function(c){html+=pill('couleur',c,(COLORS[c]||[,c])[1]);});
	if(html){html+='<button type="button" class="mdm-tout-effacer">Tout effacer</button>';}
	actifs.innerHTML=html;
}
function render(){
	loadModels().then(function(models){
		var list=filtered(models);
		grid.innerHTML=list.slice(0,shown).map(cardHtml).join('');
		if(countNum){countNum.textContent=list.length;}
		if(countS){countS.textContent=list.length>1?'s':'';}
		if(vide){vide.hidden=list.length>0;}
		if(loadWrap){loadWrap.hidden=list.length<=shown;}
		renderChips();renderActifs();syncUrl();
	});
}
cat.addEventListener('click',function(e){
	var chip=e.target.closest('.mm-chip[data-tax="difficulte"]');
	if(chip){
		var val=chip.getAttribute('data-val');
		state.difficulte=(state.difficulte===val)?'':val;
		shown=limit;render();return;
	}
	var sw=e.target.closest('.mdm-swatch-btn');
	if(sw){
		var c=sw.getAttribute('data-couleur');
		var i=state.couleurs.indexOf(c);
		if(i>-1){state.couleurs.splice(i,1);}else{state.couleurs.push(c);}
		shown=limit;render();return;
	}
	var pillBtn=e.target.closest('.mdm-pill-active');
	if(pillBtn){
		var tax=pillBtn.getAttribute('data-tax'),val=pillBtn.getAttribute('data-val');
		if(tax==='difficulte'){state.difficulte='';}
		if(tax==='s'){state.s='';}
		if(tax==='couleur'){state.couleurs=state.couleurs.filter(function(x){return x!==val;});}
		shown=limit;render();return;
	}
	if(e.target.closest('.mdm-tout-effacer')){
		state={difficulte:baseDiff,s:'',tri:'az',couleurs:[]};
		shown=limit;render();return;
	}
	if(e.target.closest('.mdm-loadmore')){shown+=limit;render();return;}
});
cat.addEventListener('change',function(e){
	if(e.target.closest('.mdm-tri')){state.tri=e.target.value;render();}
});
var searchForm=cat.querySelector('.mdm-recherche-form');
if(searchForm){
	searchForm.addEventListener('submit',function(e){
		e.preventDefault();
		state.s=(searchForm.querySelector('input').value||'').trim().toLowerCase();
		shown=limit;render();
	});
}
/* Premier rendu si état non vide dans l'URL (partage de lien filtré) */
if(state.s||state.couleurs.length||(state.difficulte&&state.difficulte!==baseDiff)||state.tri!=='az'){render();}
})();
